export default {
  loaderContainer: {
    minHeight: 100,
    flex: 1, // stretch to container
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};
